/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ValidateUpgradeSummary { 
    /**
     * Total number of entities received for validation check.
     */
    total: number;
    /**
     * Number of entities successfully passed validation check.
     */
    success: number;
    /**
     * Number of entities failed validation check.
     */
    failure: number;
}

